import React, { useEffect, useState } from "react";
import styles from "./search-bar.styles.module.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch } from "@fortawesome/free-solid-svg-icons";

export default function SearchBar({
  placeholder,
  value,
  onElementClick,
  onChange,
  searchedData,
  handleKeyEvent,
  setOpenSearch
}) {
  const [searchedResult, setSearchedResult] = useState([]);

  useEffect(() => {
    setSearchedResult(searchedData);
  }, [searchedData]);

  return (
    <div className={styles.searchBarWrapper}>
      <div className={styles.searchBar}>
        <div className={styles.searchInputs}>
            <FontAwesomeIcon icon={faSearch} className={styles.searchInputs_icons} style={{color: "gray"}}/>
            <input
                type={"text"}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                onKeyDown={(e) => {
                    handleKeyEvent(e);
                }}
            />
          <div className={styles.searchIcon}></div>
        </div>
        <div className={styles.dataResult}>
          {searchedResult?.map((val, key) => {
            return (
              <div
                className={styles.dataItem_list}
                onClick={(e) => {
                    setOpenSearch(e);
                    onElementClick(val?.series)
                }}
              >
                <div>
                  <img src={val.series.image} alt="seekho"></img>
                </div>
                <div className={styles.about}>
                  <div className={styles.title}> {val?.series?.title}</div>
                  <div className={styles.creator}>
                    {" "}
                    {val?.series?.creator?.name}
                  </div>{" "}
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {searchedResult.length > 0 && (
        <div
          className={styles.backdrop}
          onClick={() => setSearchedResult([])}
        ></div>
      )}
    </div>
  );
}
